import { faUser } from '@fortawesome/free-regular-svg-icons'
import {
  faCircleDot,
  faQrcode,
  faSignOutAlt,
  faUserDoctor,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LOGO from 'assets/images/logo.png'
import { LoginActiveView } from 'global/LoginActiveView'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import 'styles/css/header.css'
import { LoginState } from '../global/LoginState'
import { RoleState } from '../global/RoleState'
import { UserState } from '../global/UserState'
import { MenuItems, UnitAdminItems, AdminMenuItems } from './MenuItems'

const Header = () => {
  const navigate = useNavigate()
  const [loginState, setloginState] = useRecoilState(LoginState)
  const [roleState] = useRecoilState(RoleState)
  const [user] = useRecoilState(UserState)
  const [menu, setMenu] = useState([])
  const [isSmallScreen, setIsSmallScreen] = useState(false)
  const [, setLoginActiveView] = useRecoilState(LoginActiveView)
  const location = useLocation()
  const isLoginPage =
    location.pathname === '/' ||
    location.pathname === '/login' ||
    location.pathname === '/sign-in'

  const CustomMenus = (role) => {
    const roleMenus = {
      ADMIN: AdminMenuItems,
      SUPERADMIN: AdminMenuItems,
      UNITADMIN: UnitAdminItems,
      SUBUNITADMIN: UnitAdminItems,
    }
    return roleMenus[role] || MenuItems
  }

  useEffect(() => {
    setMenu(CustomMenus(user?.role))
  }, [])

  useEffect(() => {
    // Function to check screen size
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 992)
    }

    // Initial check
    checkScreenSize()

    // Add event listener to handle window resize
    window.addEventListener('resize', checkScreenSize)

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkScreenSize)
    }
  }, [])

  const renderDropdownMenu = () => (
    <>
      {!loginState.isLoggedIn ? (
        <>
          <li>
            <span
              className="dropdown-item cursor-pointer"
              onClick={() => {
                navigate('/')
              }}
            >
              <FontAwesomeIcon icon={faUserDoctor} className="me-2" />
              Login
            </span>
          </li>
        </>
      ) : (
        <>
          {/* {roleState !== "CUSTOMER" && (
            <li>
              <span
                className="dropdown-item cursor-pointer"
                onClick={() => {
                  if (roleState === "ADMIN")
                    window.location.href = `/admin/dashboard`;
                  else if (roleState === "SELLER")
                    window.location.href = `/admin/products`;
                  else window.location.href = `/admin/dashboard`;
                }}
              >
                <FontAwesomeIcon icon={faQrcode} className="me-2" /> Dashboard
              </span>
            </li>
          )} */}
          <li>
            <span
              className="dropdown-item cursor-pointer"
              onClick={() => {
                handleChangePassword()
              }}
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <FontAwesomeIcon icon={faUser} className="me-2" /> Change Password
            </span>
          </li>
          <li>
            <span
              className="dropdown-item cursor-pointer"
              onClick={() => {
                localStorage.clear()
                setloginState({
                  isLoggedIn: false,
                  role: null,
                })
                setLoginActiveView('login')
                navigate('/')
              }}
            >
              <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Logout
            </span>
          </li>
        </>
      )}
    </>
  )

  const clearCacheExceptToken = () => {
    const authToken = localStorage.getItem('token')
    localStorage.clear()
    if (authToken) {
      localStorage.setItem('token', authToken)
    }
  }

  const clearCache = () => {
    localStorage.clear()
  }

  const renderMenu = (menuItems) => (
    <ul className="navbar-nav position-relative">
      {menuItems.map((item, index) => (
        <li
          key={index}
          className="nav-item dropdown position-static py-lg-2 me-lg-n1 me-xl-0"
        >
          <span
            className="nav-link cursor-pointer"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => navigate(item.url)}
          >
            {isSmallScreen && (
              <>
                <FontAwesomeIcon icon={faCircleDot} className="me-2" />
              </>
            )}{' '}
            {item.moduleName}
          </span>
        </li>
      ))}
    </ul>
  )

  const handleChangePassword = () => {
    setLoginActiveView('change-password')
    navigate('change-password')
  }

  return (
    <>
      <header
        className="navbar navbar-expand-lg bg-body sticky-top "
        style={{ padding: '0px', height: '100px', marginBottom: '2%' }}
      >
        <div className="container py-3 d-flex justify-content-between align-items-center">
          <span
            className="navbar-brand "
            // onClick={(e) => {
            //   // debugger
            //   clearCache()
            //   navigate('/')
            // }}
          >
            <img src={LOGO} alt="OTR" style={{ height: '60px' }} />
            <div className="ms-2">
              {isSmallScreen ? (
                <p style={{ marginTop: '8%', fontSize: '60%' }}>
                  <b>हरियाणा पुलिस</b>
                  <br />
                  HARYANA POLICE
                </p>
              ) : (
                <p style={{ marginTop: '7%', fontSize: '60%' }}>
                  <b>हरियाणा पुलिस</b>
                  <br />
                  HARYANA POLICE
                </p>
              )}
            </div>
          </span>

          {!isLoginPage && <button
            type="button"
            className="navbar-toggler"
            data-bs-toggle="offcanvas"
            data-bs-target="#navbarOffcanvas"
            aria-controls="navbarOffcanvas"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>}

          <div
            className="offcanvas offcanvas-end"
            id="navbarOffcanvas"
            tabIndex="-1"
            aria-labelledby="navbarOffcanvasLabel"
          >
            <div className="offcanvas-header">
              {!isLoginPage && (
                <ul className="navbar-nav d-flex flex-row align-items-center justify-items-center position-relative">
                  <li className="nav-item dropdown position-relative">
                    <span
                      className="nav-link dropdown-toggle cursor-pointer"
                      role="button"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="false"
                      style={{ fontSize: '20px' }}
                    >
                      <FontAwesomeIcon icon={faUser} />
                    </span>
                    <ul
                      className="dropdown-menu position-absolute"
                      style={{
                        top: '100%',
                        left: '0',
                        zIndex: '1050',
                      }}
                    >
                      {renderDropdownMenu()}
                    </ul>
                  </li>
                </ul>
              )}

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>

            <div className="offcanvas-body d-flex justify-content-between">
              <div
                className="d-flex justify-content-center"
                style={{ width: '100%' }}
              >
                {loginState.isLoggedIn && <>{renderMenu(menu)}</>}
              </div>

              {!isSmallScreen && !isLoginPage && (
                <>
                  <ul className="navbar-nav ms-auto align-items-center">
                    <li className="nav-item dropdown">
                      <span
                        className="nav-link dropdown-toggle cursor-pointer"
                        role="button"
                        data-bs-toggle="dropdown"
                        data-bs-auto-close="outside"
                        aria-expanded="false"
                        style={{ fontSize: '20px' }}
                      >
                        {loginState.isLoggedIn && (
                          <>
                            Hello, <b className="ms-1">{user.username}</b>
                          </>
                        )}
                        <FontAwesomeIcon icon={faUser} className="ms-3" />
                      </span>
                      <ul className="dropdown-menu dropdown-menu-end">
                        {renderDropdownMenu()}
                      </ul>
                    </li>
                  </ul>
                </>
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

export default Header
